import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import ApproverSearch from '../../components/2compounds/ApproverSearch';

const DashboardApproverField = ({
  approver,
  error,
  locationId,
  onChange,
  supportingText = 'Only this person will receive the approval email. Other authorized reviewers can still approve the request.'
}) => (
  <FormControl error={Boolean(error)} fullWidth>
    <FormLabel required>Approval email recipient</FormLabel>
    <Box
      sx={{
        '& > div': { maxWidth: 'none' },
        mt: 0.75,
        width: '100%'
      }}
    >
      <ApproverSearch
        approver={approver}
        dashboard
        locationId={locationId}
        setApprover={onChange}
        showError={Boolean(error)}
      />
    </Box>
    <FormHelperText>{error || supportingText}</FormHelperText>
  </FormControl>
);

export default DashboardApproverField;
